'use client';

import Header from '@/components/common/Header';
import RapidaChatbot from './components/RapidaChatbot';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

export default function AboutTrackRecordPage() {
  const { t } = useLanguage();

  return (
    <main className="min-h-screen bg-background">
      <Header className="mb-0" />
      <div className="pt-16">
        {/* Hero Section */}
        <div className="bg-primary text-primary-foreground py-16 px-4">
          <div className="max-w-7xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">
              {t('trackRecord.title')}
            </h1>
            <p className="text-lg md:text-xl opacity-90 max-w-3xl mx-auto">
              {t('trackRecord.subtitle')}
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 py-12">
          {/* Team Introduction */}
          <div className="mb-12">
            <div className="bg-card rounded-lg border border-border p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Icon name="UserGroupIcon" size={32} variant="outline" className="text-primary flex-shrink-0" />
                <div>
                  <h2 className="text-2xl font-heading font-bold text-foreground mb-3">
                    {t('trackRecord.welcomeTitle')}
                  </h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    {t('trackRecord.welcomeDescription1')}
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('trackRecord.welcomeDescription2')}
                  </p>
                </div>
              </div>

              {/* Quick Stats */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-8">
                <div className="bg-muted rounded-lg p-4 text-center">
                  <Icon name="ClockIcon" size={24} variant="outline" className="text-accent mx-auto mb-2" />
                  <p className="text-2xl font-heading font-bold text-foreground">24/7</p>
                  <p className="text-xs text-muted-foreground">{t('trackRecord.supportAvailable')}</p>
                </div>
                <div className="bg-muted rounded-lg p-4 text-center">
                  <Icon name="ChatBubbleLeftRightIcon" size={24} variant="outline" className="text-accent mx-auto mb-2" />
                  <p className="text-2xl font-heading font-bold text-foreground">{t('trackRecord.instant')}</p>
                  <p className="text-xs text-muted-foreground">{t('trackRecord.responseTime')}</p>
                </div>
                <div className="bg-muted rounded-lg p-4 text-center">
                  <Icon name="UserGroupIcon" size={24} variant="outline" className="text-accent mx-auto mb-2" />
                  <p className="text-2xl font-heading font-bold text-foreground">{t('trackRecord.expert')}</p>
                  <p className="text-xs text-muted-foreground">{t('trackRecord.teamMembers')}</p>
                </div>
                <div className="bg-muted rounded-lg p-4 text-center">
                  <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success mx-auto mb-2" />
                  <p className="text-2xl font-heading font-bold text-foreground">{t('trackRecord.proven')}</p>
                  <p className="text-xs text-muted-foreground">{t('trackRecord.reportProblem')}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Chatbot Section */}
          <div className="mb-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-heading font-bold text-foreground mb-3">
                {t('trackRecord.chatTitle')}
              </h2>
              <p className="text-muted-foreground max-w-2xl mx-auto">
                {t('trackRecord.chatDescription')}
              </p>
            </div>
            <RapidaChatbot />
          </div>

          {/* Additional Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-accent/5 border border-accent/20 rounded-lg p-6">
              <div className="flex items-start space-x-3">
                <Icon name="LightBulbIcon" size={24} variant="outline" className="text-accent flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    {t('trackRecord.quickTips')}
                  </h3>
                  <ul className="text-sm text-muted-foreground space-y-2">
                    <li>• {t('trackRecord.tip1')}</li>
                    <li>• {t('trackRecord.tip2')}</li>
                    <li>• {t('trackRecord.tip3')}</li>
                    <li>• {t('trackRecord.tip4')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}